import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import AdministrationMain from './administration-main.component';
import DataProtection from '../dataprotection/dataprotection.component';
import NotFound from '../../../common/not-found/not-found.component';
import { AuthGuard } from '../../auth/auth.guard';
import { PublisherApp } from '../../../publisher/src/publisher-ui/publisher.component';
import { TroubleShootingApp } from '../../../troubleshooting/src/troubleshooting-ui/troubleshooting.component';
import { DeploymentContainerLanding } from './deployment-container/dc-landing.component';
import { InterConnectConfigurationLanding } from './interconnect-configuration/icc-landing.component';
import { AuditLogApp } from '../../../auditlog/src/auditlog-ui/auditlog.component';
import { SupportComponent } from './support/support.component';
import { DiceIntegrationComponent } from '../administration-main/dice-integration/dice-integration.component';

@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: 'administration', component: AdministrationMain, canActivate: [AuthGuard],
                children: [
                    { path: '', redirectTo: 'upgradeapp', pathMatch: 'full' },
                    {
                        path: 'troubleshooting', component: TroubleShootingApp,
                        canActivate: [AuthGuard]
                    },
                    {
                        path: 'upgradeapp', component: PublisherApp,
                        canActivate: [AuthGuard]
                    },
                    {
                        path: 'deploymentcontainer', component: DeploymentContainerLanding,
                        canActivate: [AuthGuard]
                    },
                    {
                        path: 'interConnectConfiguration', component: InterConnectConfigurationLanding,
                        canActivate: [AuthGuard]
                    },
                    {
                        path: 'auditlogapp', component: AuditLogApp,
                        canActivate: [AuthGuard]
                    },
                    {
                        path: 'diceIntegration', component: DiceIntegrationComponent,
                        canActivate: [AuthGuard]
                    },
                    {
                        path: 'support', component: SupportComponent,
                        canActivate: [AuthGuard]
                    },
                    { path: '**', component: NotFound }
                ]
            }
        ])
    ],
    exports: [
        RouterModule
    ]
})
export class AdministrationRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/components/administration-main/administration-routing.module.ts